import React from 'react';
import { IconPropTypes } from 'ggApp/types/propTypes';

const Link = ({ className, color, size }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10.293 7.7071C9.90251 7.31658 9.90251 6.68341 10.293 6.29289L12.293 4.29289C14.3404 2.24551 17.6599 2.24551 19.7073 4.29289C21.7546 6.34027 21.7546 9.65972 19.7073 11.7071L17.7073 13.7071C17.3167 14.0976 16.6836 14.0976 16.293 13.7071C15.9025 13.3166 15.9025 12.6834 16.293 12.2929L18.293 10.2929C19.5594 9.02656 19.5594 6.97343 18.293 5.7071C17.0267 4.44077 14.9736 4.44077 13.7073 5.7071L11.7073 7.7071C11.3167 8.09763 10.6836 8.09763 10.293 7.7071Z"
            fill={color}
        />
        <path
            d="M13.707 16.2929C14.0975 16.6834 14.0975 17.3166 13.707 17.7071L11.7069 19.7071C9.65957 21.7545 6.34011 21.7545 4.29274 19.7071C2.24536 17.6597 2.24536 14.3403 4.29273 12.2929L6.29274 10.2929C6.68326 9.90236 7.31642 9.90236 7.70695 10.2929C8.09747 10.6834 8.09747 11.3166 7.70695 11.7071L5.70695 13.7071C4.44062 14.9734 4.44062 17.0266 5.70695 18.2929C6.97328 19.5592 9.0264 19.5592 10.2927 18.2929L12.2927 16.2929C12.6833 15.9024 13.3164 15.9024 13.707 16.2929Z"
            fill={color}
        />
        <path
            d="M8.46491 14.121C8.07439 14.5115 8.07439 15.1447 8.46491 15.5352C8.85544 15.9258 9.4886 15.9258 9.87913 15.5352L15.536 9.87837C15.9265 9.48785 15.9265 8.85469 15.536 8.46416C15.1455 8.07364 14.5123 8.07364 14.1218 8.46416L8.46491 14.121Z"
            fill={color}
        />
    </svg>
);

Link.propTypes = {
    ...IconPropTypes,
};

Link.defaultProps = {
    className: '',
    color: '#333333',
    size: '24',
};

export default Link;
